module.exports = __webpack_public_path__ + "img/astana4.7b0978d3.jpg";